<template>
  <item-form />
</template>

<script>
import ItemForm from '@/views/Services/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    ItemForm,
  },
}
</script>
